import { AppPalette } from '../../colors'

export const MuiIconButton = {
  styleOverrides: {
    root: {
      borderRadius: '5px',
      '&.icon-button-base': {
        borderRadius: '5px',
        border: '0.5px solid rgba(201, 209, 217,0.6)',
        backgroundColor: 'rgb(33, 38, 45)',
        color: 'rgb(201, 209, 217)',
        '&:hover': {
          backgroundColor: AppPalette.YELLOW.main,
        },
      },
      '&.no-border': {
        height: '18px',
        border: 'none',
        width: '18px',
        color: 'inherit',
        padding: '0',
      },
    },
    sizeSmall: {
      width: '24px',
      height: '24px',
    },
    sizeMedium: {
      width: '40px',
      height: '40px',
    },
    sizeLarge: {
      width: '50px',
      height: '50px',
    },
  },
}
